<template>
  <AppHeader :action="{text: 'Add', route: 'CreateDeliveryPerson'}">All Delivery Persons</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="responsive-table">
      <table>
        <thead>
          <tr>
            <th rowspan="2">ID</th>
            <th rowspan="2">Name</th>
            <th rowspan="2">Last OTP</th>
            <th rowspan="2">Groups</th>
            <th rowspan="2">Custs</th>
            <th colspan="13">Today's Delivery Statistics</th>
            <th rowspan="2">Actions</th>
          </tr>
          <tr>
            <th></th>
            <th>Custs</th>
            <th>Dels</th>
            <th>Qty</th>
            <th>Samples</th>
            <th>Orders</th>
            <th>First</th>
            <th>Last</th>
            <th>Duration</th>
            <th>Delivery</th>
            <th>In Time</th>
            <th>Out Time</th>
            <th>Trip Status</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="item in persons" :key="item.id" :id="item.id" :class="{'bg-red-200': item.status == 'inactive'}">
            <td>#{{ item.id }}</td>
            <td>
              <router-link :to="{name: 'ViewDeliveryPerson', params: {id: item.id}}">{{ item.name }}</router-link>
            </td>
            <td>{{ item.otp }}</td>
            <td>{{ item.groups_count }}</td>
            <td>{{ item.customers_count }}</td>
            <td v-if="item.delivery_stats"><i class="ion-md-arrow-forward"></i></td>
            <td v-else></td>
            <td>{{ item.delivery_stats != null ? item.delivery_stats.customers : null }}</td>
            <td>{{ item.delivery_stats != null ? item.delivery_stats.deliveries : null }}</td>
            <td>{{ item.delivery_stats != null ? item.delivery_stats.quantity : null }}</td>
            <td>{{ (item.delivery_stats != null && item.delivery_stats.leads != 0) ? item.delivery_stats.leads : null }}</td>
            <td>{{ (item.delivery_stats != null && item.delivery_stats.orders != 0) ? item.delivery_stats.orders : null }}</td>
            <td>{{ item.delivery_stats != null ? item.delivery_stats.first_delivery_at : null }}</td>
            <td>{{ item.delivery_stats != null ? item.delivery_stats.last_delivery_at : null }}</td>
            <td>{{ item.delivery_stats != null ? Math.round(item.delivery_stats.duration) + ' mins' : null }}</td>
            <td v-if="item.delivery_stats">
              <small class="mr-1" v-for="(count, status) in item.delivery_stats.statuses" :key="status">{{ status }}: {{ count }}</small>
            </td>
            <td v-else></td>
            <td>{{ item.trip != null ? toDate(item.trip.started_at, true) : null }}</td>
            <td>{{ item.trip != null ? toDate(item.trip.ended_at, true) : null }}</td>
            <td v-if="item.trip">
              <button v-if="item.trip.status == 'created'" @click="tripApprove(item.trip)" class="px-2 py-1 text-xs leading-none rounded-full bg-slate-300"><i class="ion-md-done-all"></i> Approve</button>
              <span v-else class="text-sm">{{ item.trip.status }}</span>
            </td>
            <td v-else></td>
            <td class="flex items-center gap-x-3">
              <a :href="('tel:' + item.phone)"><i class="ion-md-call"></i></a>
              <router-link :to="{name: 'ReportDeliveryPersonsAttendanceSummary', query: {id: item.id}}" class="px-2 py-1 mr-1 text-xs leading-none bg-green-300 rounded-full">
                <button>Attendance</button>
              </router-link>
              <router-link v-if="item.has_payment_access" :to="{ name: 'DeliveryPersonsTransaction', params: {id: item.id, }}" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-slate-400">
                <button>Salary</button>
              </router-link>
              <router-link :to="{ name: 'CreateEntityLog', params: { id: item.id }, query: { name: item.name }}" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-blue-500">
                <button>Log</button>
              </router-link>
              <a v-if="item.trip && item.trip.check_in_image" :href="item.trip.check_in_image.src" target="_system" title="Trip Check In Image"><i class="ion-md-image"></i></a>
              <template v-if="item.status == 'active'">
                <button @click="updateStatus(item.id, 'inactive')" class="px-2 py-1 mr-1 text-xs leading-none bg-red-300 rounded-full">Inactive</button>
              </template>
              <template v-else>
                <button @click="updateStatus(item.id, 'active')" class="px-2 py-1 mr-1 text-xs leading-none bg-green-300 rounded-full">Active</button>
                <button @click="updateStatus(item.id, 'removed')" class="px-2 py-1 mr-1 text-xs leading-none rounded-full bg-rose-400">Remove</button>
              </template>
            </td>
          </tr>

        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'DeliveryPersons',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      persons: [],
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'delivery-persons', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.persons = resp.data.delivery_persons;
        }
      });
    },

    tripApprove(trip) {
      this.state = 'loading';

      this.request('GET', 'delivery-persons/' + trip.delivery_person_id + '/trips/' + trip.id + '/approve', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.getData();
        }
      });
    },

    updateStatus(dpId, status) {
      this.request('GET', 'delivery-persons/' + dpId + '/' + status, {}, (resp) => {
        if (resp.success) {
          this.getData();
        }
      });
    }
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
